import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import MenuSettingModel from "../menuSetting.model";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { take } from "rxjs/operators";

@Component({
  selector: "ngx-menu-setting",
  templateUrl: "./menu-setting.component.html",
  styleUrls: ["./menu-setting.component.scss"],
})
export class MenuSettingComponent extends BaseFormComponent<MenuSettingModel> {
  logoFormData: FormData = new FormData();

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.getMenuSetting();
  }

  async ngOnInit() {
    this.apiName = "Peripheral";
    this.label = "";
    super.ngOnInit();
  }

  addControl() {
    this.setValues();
    this.cd.markForCheck();
  }

  uploadLogo(event) {
    if (event.target.files && event.target.files.length) {
      const max_size = 100000;
      const max_height = 256;
      const max_width = 265;

      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];

        if (file.size > max_size) {
          let error =
            this.translate("ClientApp.FrontOffice.Portal.MenuSetting.UploadedImageSizeMustLessThan") +
            max_size / 1000 +
            this.translate("ClientApp.FrontOffice.Portal.MenuSetting.BeKb");
          this.sts.showDialog(error, this.translate("ClientApp.FrontOffice.Portal.MenuSetting.Error"));
          return false;
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
          let image = new Image();
          image.src = e.target.result;

          image.onload = (rs: any): any => {
            const img_height = rs.currentTarget["height"];
            const img_width = rs.currentTarget["width"];

            if (img_height > max_height || img_width > max_width) {
              let error = this.translate("ClientApp.FrontOffice.Portal.MenuSetting.ImageSizeNotAllowed");
              this.sts.showDialog(error, this.translate("ClientApp.FrontOffice.Portal.MenuSetting.Error"));
              return false;
            } else {
              this.logoFormData.append("logoImage", file);
              this.httpCommonService
                .upload("Peripheral/RestaurantLogo", this.logoFormData)
                .pipe(take(1))
                .subscribe(
                  (res: any) => {
                    if (res) {
                      this.model = res;
                      this.sts.showToast("success", this.translate("ClientApp.FrontOffice.Portal.MenuSetting.LogoSuccessfullyLoaded"));
                    }
                  },
                  (err) => {
                    this.sts.showToast("danger", this.translate("ClientApp.FrontOffice.Portal.MenuSetting.ErrorLoading"));
                  }
                );
            }
          };
        };

        reader.readAsDataURL(file);
      }
    }
  }

  saveMenuSetting() {
    this.httpCommonService
      .create("Peripheral/MenuSetting", this.formGroup.value)
      .pipe(take(1))
      .subscribe((res) => {
        if (res) this.sts.showToast("success", this.translate("ClientApp.FrontOffice.Portal.MenuSetting.InformationSuccessfullySaved"));
      });
  }

  getMenuSetting() {
    this.httpCommonService
      .get("Peripheral/MenuSetting")
      .pipe(take(1))
      .subscribe((x: any) => {
        this.model = x;
        this.setValues();
      });
  }

  private setValues() {
    this.setValue("showAllCategories", this.model.ShowAllCategories);
    this.setValue("instagram", this.model.Instagram);
    this.setValue("telegram", this.model.Telegram);
    this.setValue("twitter", this.model.Twitter);
    this.setValue("facebook", this.model.Facebook);
    this.setValue("whatsApp", this.model.WhatsApp);
    this.setValue("website", this.model.Website);
  }
}
